import { i18nCommons, navigatorLanguage } from '@geovelo-frontends/commons';
import { Box, Typography } from '@mui/material';
import { Link } from 'gatsby';
import { withPrismicUnpublishedPreview } from 'gatsby-plugin-prismic-previews';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import Button from '../components/button';

function NotFoundPage() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18nCommons.changeLanguage(navigatorLanguage);
    i18n.changeLanguage(navigatorLanguage);
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${t('geovelo.pages_titles.page_not_found')}`}</title>
      </Helmet>
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        flexGrow={1}
        justifyContent="center"
        padding={3}
      >
        <Typography component="h1" variant="h2">
          404
        </Typography>
        <Typography fontSize="2em">{t('geovelo.page_not_found')}</Typography>
        <Button color="primary" component={Link} sx={{ marginTop: 5 }} to="/" variant="contained">
          {t('geovelo.actions.back_home')}
        </Button>
      </Box>
    </>
  );
}

export default withPrismicUnpublishedPreview(NotFoundPage);
